import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 118.1 99.45"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 99.45h3.71s1.48-21.32 16.86-18.91 34.46 2.23 36.78-.65c3.51-4.36-37.7-6.02-44.93-.65-7.23 5.38 6.12-14.09 15.84-13.35s38.75 7.82 52.72.91c9.22-4.56-48.37-7.7-53.35-3.77-4.98 3.93 4.84-6.55 12.84-10.88s7.99-6.95 23.98-2.23c15.98 4.72 29.21 3.8 30.79 2.36 1.57-1.44-14.54-9.44-25.41-8.91s-18.73.66-19.52 1.31c-.79.65 15.59-11.28 20.96-11.93s13.1-1.18 21.36-.79c10.21.49 24.11-6.03 25.41-8.13 1.31-2.1-15.72-2.36-23.71.13s-23.84 5.77-25.29 7.47c-1.44 1.71.92-3.67 9.56-7.08C87.25 20.94 107.35 5.72 106.19.7c-.56-2.43-22.61 8.18-36.11 24.96-13.49 16.79-22.54 17.31-22.54 17.31s9.3-11.93 14.41-19.01C67.06 16.88 72.43 1.41 71.77.09c-.66-1.31-16.25 13.37-19.13 21.37-2.88 8-6.42 22.03-8.25 23.21-1.83 1.18-11.27 10.62-12.05 10.49s.66-7.34 2.88-11.28 1.18-23.73-2.75-26.23c-3.93-2.49-6.02 15.48-5.37 18.23.66 2.75 4.73 17.87 1.91 19.97C22.33 60.84.41 83.95 0 99.45Z",
      style: {"fill":"#1b3a32"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "CY-logo"}) } }